module.exports = __webpack_public_path__ + "static/media/YF67_1.d459a309.jpg";